import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TweenLite, TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {PearlHarborRestoreXSWinRunner} from "../../presentationRunners/maingame/PearlHarborRestoreXSWinRunner";
import {PearlHarborRestoreResizeArea} from "../../presentationRunners/PearlHarborRestoreResizeArea";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborScatterSymbol} from "../../reels/PearlHarborScatterSymbol";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class PearlHarborIdlePresentation implements FlowStatePresentation {
    private _presentations: SimplePresentation[];

    constructor() {
        this._presentations = [
            new PearlHarborRestoreResizeArea,
            new PearlHarborRestoreXSWinRunner
        ];
    }

    private onComplete(flowStateController: FlowStateController): void {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => SlotGame.apiPlugin.betHandler.zeroBet());

        if (tl.duration() == 0) {
            tl.add(TweenLite.to(this, {duration: 0.001}));
        }

        if (PearlHarbor.foregroundElements.boostedBet && PearlHarbor.model.data.nextMode === GameMode.NORMAL) {
            tl.add(()=>PearlHarbor.foregroundElements.startAnimation(), 7);
        }
        tl.add(() => flowStateController.finish());
    }

    start(flowStateController: FlowStateController) {
        SimplePresentationRunner.run(this._presentations, () => this.onComplete(flowStateController), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }
}